import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const LED_Component = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="LED and Seven Segment Display"
      videos={[
        "https://www.youtube.com/embed/qc3h2cl5z3Q", // First LED video
        "https://www.youtube.com/embed/XzzHbw4n6Ew", // Second LED video
      ]}
      takeaways={[
        {
          text: "Questions will come indirectly and involve seven segment display applications.",
        },
        {
          text: "The code for seven segment display follows similar patterns but requires specific calculations before displaying on the LED.",
        },
        {
          text: "Be prepared to display numbers on two seven segment displays connected to different ports.",
        },
      ]}
      questions={[
        "Write an 8051 ALP to find numbers divisible by both 3 and 7 in the range 1 to 99 and display them on two seven-segment displays connected to P0 and P1.",
        "Write an 8051 ALP to multiply two numbers without using MUL AB instruction and display the product on seven-segment displays connected to P0 and P1.",
        "Write an 8051 assembly language program that gets 8-bit data from P0, sends it to P1, and turns on an LED connected to P2.5 for 100 microseconds when P3.3 (INT1) goes low.",
      ]}
      exampleVideos={[]} // No extra example videos
    />
  );
}

export default LED_Component;
